import React from 'react';
//import GoogleMapReact from 'google-map-react';
//import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
//import GoogleMapMarker from '../content/maps/google_map_marker';

const HotelMap = ({ blok, hotel }) => {
  return <></>;

  /*
  const { name, geoCoordinateLat, geoCoordinateLong } = hotel;

  // Default zoom level. If not set, it will be 15
  //   const deafultZoomLevel = parseInt(blok.zoom_level) || 15;

  const defaultProps = {
    center: {
      // Default center of the map. If not set, it will be Gothenburg
      lat: geoCoordinateLat || 57.69721634340465,
      lng: geoCoordinateLong || 11.976116999692321,
    },
    // Default zoom level. If not set, it will be 15
    zoom: parseInt(blok.zoom_level) || 15,
  };

  if (!hotel.geoCoordinateLat && !hotel.geoCoordinateLong) {
    return;
  }

  return (
    // Important! Always set the container height explicitly
    <div
      style={{ height: blok.height || '90vh', width: blok.width || '100%' }}
      className="col-span-12 rounded mt-12 max-h-[500px]"
      {...storyblokEditable(blok)}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        className="rounded"
      >
        {blok.map_markers &&
          blok.map_markers.map((nestedBlok) => (
            <StoryblokComponent
              lat={nestedBlok.latitude_marker}
              lng={nestedBlok.longitude_marker}
              blok={nestedBlok}
              key={nestedBlok._uid}
              hotel={hotel}
              expanded={true}
            />
          ))}
        {geoCoordinateLat && geoCoordinateLong && (
          <GoogleMapMarker
            lat={geoCoordinateLat}
            lng={geoCoordinateLong}
            text={name}
            hotel={hotel}
            expanded={true}
          />
        )}
      </GoogleMapReact>
    </div>
  );*/
};

export default HotelMap;
